export enum ShadowToken {
  Level1 = '0 0.1rem 0.2rem 0 rgba(16, 24, 40, 0.05)',
  Level2 = '0 0.1rem 0.3 0 rgba(16, 24, 40, 0.10)',
  Level3 = '0 0.4rem 0.8rem -0.2rem rgba(16, 24, 40, 0.10)',
  Level4 = '0 1.2px 1.6rem -0.4rem rgba(16, 24, 40, 0.08)',
  Level5 = '0 2.0rem 2.4rem -0.4rem rgba(16, 24, 40, 0.08)',
  Level6 = '0 2.4rem 4.8rem -1.2rem rgba(16, 24, 40, 0.18)',
  Level7 = '0 3.2rem 6.4rem -1.2rem rgba(16, 24, 40, 0.14)',
}

export default ShadowToken

export type TShadowV2 =
  | 'level1'
  | 'level2'
  | 'level3'
  | 'level4'
  | 'level5'
  | 'level6'
  | 'level7'
